var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOnlineGamingSvg = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 15,
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_12111_26812)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.92188 5.74935C2.04688 6.62435 1.17188 7.61602 1.17188 8.95768C1.17188 9.37901 1.25486 9.79621 1.41609 10.1855C1.57733 10.5747 1.81365 10.9284 2.11157 11.2263C2.71325 11.828 3.52931 12.166 4.38021 12.166C5.43021 12.166 6.13021 11.8743 7.00521 10.9993C7.88021 11.8743 8.58021 12.166 9.63021 12.166C10.0515 12.166 10.4687 12.083 10.858 11.9218C11.2472 11.7606 11.6009 11.5242 11.8988 11.2263C12.1968 10.9284 12.4331 10.5747 12.5943 10.1855C12.7556 9.79621 12.8385 9.37901 12.8385 8.95768C12.8385 7.61602 11.9635 6.62435 11.0885 5.74935L7.00521 1.66602L2.92188 5.74935Z",
  stroke: "#181916",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i_12111_26812)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 11V13.3333",
  stroke: "#181916",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_12111_26812",
  x: 0.671875,
  y: 1.16602,
  width: 13.6641,
  height: 12.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12111_26812"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i_12111_26812",
  x: 6.5,
  y: 10.5,
  width: 2,
  height: 4.33301,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12111_26812"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOnlineGamingSvg);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";